import { render, staticRenderFns } from "./CreateMerchantStep3.vue?vue&type=template&id=01a5139d&scoped=true&"
import script from "./CreateMerchantStep3.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantStep3.vue?vue&type=script&lang=js&"
import style0 from "./CreateMerchantStep3.vue?vue&type=style&index=0&id=01a5139d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5139d",
  null
  
)

export default component.exports